<template>
  <!-- 单个打印包裹信息 -->
  <div>
    <div class="main" id="print" ref="print">
      <div class="content">
        <div class="title">包裹信息</div>
        <div class="footer">
          <div class="text">
            <div class="row">
              <div class="label">需上架：</div> {{ lastFewDays(datas.datetime_pay_confirm, 7) }}
            </div>
            <div class="row">
              <div class="label">配货员：</div> {{ datas.p_name }}
            </div>
            <div class="row">
              <div class="label">业务员：</div> {{ datas.y_name }}
            </div>
            <div class="row">
              <div class="label">采购员：</div> {{ datas.g_name }}
            </div>
            <div v-if="datas.user" class="row">
              <div class="label">客户名：</div> {{ datas.user.realname }}
            </div>
            <div class="row">
              <div class="label">订单号：</div> {{ datas.order_sn }}
            </div>
            <div class="row">
              <div class="label">商品番号：</div> {{ datas.sorting }}
            </div>
            <div class="row" style="height:150px;margin-bottom: 0;">
              <div class="label">商品属性：</div>
              <div class="detail_y">
                <span v-for="(item, index) in datas.detail_y" :key="index">
                  {{ item.key }}:{{ item.value }}
                </span>
              </div>
            </div>
          </div>
          <div class="tiaoxingma">
            <div class="item">
              <div class="item-top"> <span class="label">交易号：</span>{{ datas.purchase_no }}</div>
              <!-- 一维码 -->
              <div class="item-footer">
                <canvas id="purchase_no" />
              </div>
            </div>
            <div class="item">
              <div class="item-top"> <span class="label">物流号：</span>{{ datas.express_no }}</div>
              <!-- 一维码 -->
              <div class="item-footer">
                <canvas id="express_no" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { lastFewDays } from "@/utlis/date";
export default {
  props: {
    datas: { type: Object },
  },
  data() {
    return {
      lastFewDays,

    };
  },
  created() {
    // this.$nextTick(() => {
    //   this.$print(this.$refs.print)
    // })
  },
  mounted() {
    this.getJsBarcode("#purchase_no", this.datas.purchase_no);
    if (this.datas.express_no) {
      this.getJsBarcode("#express_no", this.datas.express_no);
    }

  },
  methods: {
    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 240,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },

  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 1061px;
  height: 1652px;
  background: #fff;
  padding: 48px;
  color: #000000 !important;

  div {
    box-sizing: border-box;
  }

  .content {
    width: 1061px;
    border: 8px solid #000000;
    border-top: 0;
    position: relative;
    padding-top: 160px;

    .title {
      position: absolute;
      left: -8px;
      top: 0;
      width: 1061px;
      height: 160px;
      background: #000000;
      text-align: center;
      line-height: 160px;
      font-size: 80px;
      font-weight: 600;
      color: #ffffff;
      margin: 0;
    }

    .footer {
      width: 100%;
      height: 1292px;
      padding: 22px;

      .text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 380px;
        padding: 4px 0;
        margin-bottom: 12px;

        .row {
          display: flex;
          flex-wrap: wrap;
          font-size: 45px;
          line-height: 65px;
          font-weight: 600;
          color: #000000;
          margin-bottom: 12px;

          .label {
            width: 250px;
            font-weight: 500;
            margin-right: 10px;
          }

          .detail_y {
            flex: 1
          }
        }
      }

      .tiaoxingma {
        .item {
          width: 100%;
          height: 320px;
          margin-bottom: 22px;

          &:nth-last-child(1) {
            margin: 0;
          }

          .item-top {
            display: flex;
            height: 60px;
            line-height: 60px;
            font-size: 50px;
            font-weight: 600;
            color: #000000;
            margin-bottom: 22px;

            span {
              font-weight: 500;
              width: 250px;
            }
          }

          .item-footer {
            width: 100%;
            height: 200px !important;
            overflow: hidden;

            img {
              width: 941px;
              height: 200px !important;
              overflow: hidden;

            }
          }
        }
      }
    }
  }
}
</style>
